import { CloudCommand } from "../types.js";

export const removePending: CloudCommand = {
    action: "INVITATION/REMOVE_PENDING",
    commandName: "invitation.removePending",
    buildPayload: ({ dateDelete }) => ({ dateDelete }),
};
